/**
 * Публичные юридические тексты Бай.Спорт (черновики для публикации).
 * Перед продом: заполнить LEGAL_OPERATOR и согласовать с юристом.
 *
 * Пакет (отдельные документы — требование ст. 9 152-ФЗ к согласию):
 * 1) Оферта (договор SaaS)
 * 2) Политика конфиденциальности
 * 3) Политика cookies
 * 4) Условия платежей
 * 5) Согласие клиента клуба
 * 6) Согласие владельца клуба
 */
import { SITE_ORIGIN } from "../config/site";
import { LEGAL_PATHS } from "./legalPaths";

/** Заполните своими данными (ИП/ООО, ИНН, адрес, email для ПДн). */
export const LEGAL_OPERATOR = {
  brandName: "Бай.Спорт",
  siteUrl: SITE_ORIGIN,
  legalName: "ИП Байков Владимир Алексеевич",
  entityName: "ИП Байков Владимир Алексеевич",
  inn: "500921103162",
  ogrnOrOgrnip: "ОГРНИП 325508100673982",
  legalAddress: "Московская область, г.о. Домодедово, с. Растуново",
  privacyEmail: "bay.code@mail.ru",
  supportEmail: "bay.code@mail.ru",
};

/** Версия редакции (для ссылок и будущего лога акцепта). */
export const LEGAL_DOCS_VERSION = "2026-09-07";
const updated = "7 сентября 2026 г.";

function p(...paragraphs) {
  return paragraphs;
}

export const LEGAL_DOCUMENTS = {
  offer: {
    id: "offer",
    path: LEGAL_PATHS.offer,
    title: "Пользовательское соглашение (публичная оферта)",
    description:
      "Публичная оферта на оказание услуг доступа к SaaS Бай.Спорт для спортивных клубов.",
    updatedAt: updated,
    version: LEGAL_DOCS_VERSION,
    sections: [
      {
        heading: "1. Общие положения",
        paragraphs: p(
          `1.1. Настоящий документ является публичной офертой ${LEGAL_OPERATOR.legalName} (далее — «Исполнитель») в смысле ст. 435, 437 Гражданского кодекса РФ заключить договор на использование облачного сервиса «${LEGAL_OPERATOR.brandName}» (далее — «Сервис») на условиях ниже (далее — «Оферта», «Договор»).`,
          `1.2. Акцепт Оферты (ст. 438 ГК РФ): отдельная отметка о принятии Оферты при регистрации / создании клуба и последующая регистрация либо оплата подписки. Текст Оферты доступен до акцепта; его можно сохранить или распечатать со страницы ${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.offer}.`,
          "1.3. Согласие на обработку персональных данных владельца оформляется отдельным документом и отдельной отметкой и не заменяется акцептом настоящей Оферты.",
          `1.4. Сервис доступен по адресу ${LEGAL_OPERATOR.siteUrl} и на поддоменах / сайтах клубов. Состав функций зависит от тарифа и настроек клуба. Редакция Оферты: ${LEGAL_DOCS_VERSION} от ${updated}.`,
          `1.5. Реквизиты Исполнителя: ${LEGAL_OPERATOR.entityName}; ИНН ${LEGAL_OPERATOR.inn}; ${LEGAL_OPERATOR.ogrnOrOgrnip}; адрес: ${LEGAL_OPERATOR.legalAddress}. Контакт: ${LEGAL_OPERATOR.supportEmail}.`,
          `1.6. Связанные документы (неотъемлемы в соответствующей части): Политика конфиденциальности (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.privacy}), Политика cookies (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.cookies}), Условия платежей (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.payments}).`,
        ),
      },
      {
        heading: "2. Термины",
        paragraphs: p(
          "2.1. Заказчик — лицо, акцептовавшее Оферту (владелец клуба / уполномоченный представитель).",
          "2.2. Клуб — спортивная организация / секция / ИП, для которого открыт кабинет в Сервисе.",
          "2.3. Клиент клуба — спортсмен, родитель или иное лицо, данные которого ведутся в CRM клуба.",
          "2.4. Подписка — возмездный доступ Заказчика к функциям Сервиса по выбранному тарифу.",
        ),
      },
      {
        heading: "3. Предмет договора",
        paragraphs: p(
          "3.1. Исполнитель оказывает Заказчику услуги по предоставлению удалённого доступа к Сервису (SaaS): учёт клиентов, расписание, журнал посещаемости, абонементы и платежи клуба, кабинеты клиентов и персонала, сайт/виджеты клуба, иные функции тарифа.",
          "3.2. Заказчику предоставляется простая (неисключительная) лицензия на использование интерфейса Сервиса в пределах функций тарифа на срок оплаченного (или пробного) доступа. Исходный код Сервиса не передаётся.",
          "3.3. Исполнитель не оказывает спортивные, медицинские или образовательные услуги Клиентам клуба и не является стороной договоров клуба с Клиентами.",
          "3.4. Онлайн-оплата абонементов и разовых занятий Клиентами — расчёты между Клиентом и клубом через эквайринг клуба. Исполнитель обеспечивает техническую интеграцию и не получает эти суммы как плату за свои услуги (см. Условия платежей).",
        ),
      },
      {
        heading: "4. Регистрация и аккаунт",
        paragraphs: p(
          "4.1. Заказчик указывает достоверные данные, обеспечивает конфиденциальность пароля и средств доступа.",
          "4.2. Заказчик отвечает за действия всех пользователей кабинета клуба (администраторы, тренеры и др.).",
          "4.3. Исполнитель вправе отказать в регистрации или ограничить доступ при нарушении Оферты, подозрении на мошенничество либо по требованию закона.",
          "4.4. Заказчик обязуется немедленно сообщить о компрометации доступа на адрес поддержки.",
        ),
      },
      {
        heading: "5. Тарифы, пробный период и подписка",
        paragraphs: p(
          "5.1. Стоимость, состав тарифов и условия пробного периода публикуются в интерфейсе и/или на сайте. Цена указывается в российских рублях.",
          "5.2. Пробный период (если предоставлен) даёт доступ на срок, указанный в интерфейсе; по окончании доступ ограничивается до оплаты тарифа, если иное не указано.",
          "5.3. Оплата подписки, автопродление, смена тарифа, чеки и возвраты — в Условиях платежей и правилах платёжного провайдера.",
          "5.4. Неоплата или просрочка может повлечь ограничение или приостановку доступа (включая кабинеты клуба) до погашения задолженности.",
        ),
      },
      {
        heading: "6. Платежи Клиентов клуба",
        paragraphs: p(
          "6.1. Клуб подключает эквайринг своими реквизитами / договором с провайдером (ЮKassa, Т‑Банк и др.).",
          "6.2. Получатель денег при оплате абонемента / разового занятия Клиентом — клуб (или лицо по договору клуба с эквайером), не Исполнитель.",
          "6.3. Клуб как продавец/исполнитель услуг перед Клиентом самостоятельно отвечает за цену, качество занятий, возвраты, претензии, кассовые чеки (54‑ФЗ — если применимо) и условия эквайера.",
          "6.4. Исполнитель не гарантирует одобрение платежа банком и не участвует в спорах клуба с Клиентом, кроме доказанной вины Исполнителя в техническом сбое интеграции.",
        ),
      },
      {
        heading: "7. Поручение на обработку персональных данных",
        paragraphs: p(
          "7.1. Заказчик — оператор ПДн Клиентов клуба, сотрудников и иных лиц, чьи данные он вносит в Сервис (далее — «ПДн Клуба»).",
          "7.2. Акцептуя Оферту, Заказчик поручает Исполнителю обработку ПДн Клуба в объёме, необходимом для оказания услуг: сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, передача (доступ сотрудникам Исполнителя и подрядчикам в пределах поручения), блокирование, удаление, уничтожение — в электронных базах на территории РФ.",
          "7.3. Цели поручения: предоставление и поддержка Сервиса, резервное копирование, безопасность, исполнение договора, техническая передача данных платёжному провайдеру при онлайн-оплате по инициативе клуба/Клиента.",
          "7.4. Исполнитель обрабатывает ПДн Клуба только в рамках поручения; применяет меры защиты; не использует ПДн Клуба для своих целей, не связанных с оказанием услуг Заказчику.",
          "7.5. Заказчик гарантирует наличие правовых оснований передачи ПДн Клуба и самостоятельно получает согласия Клиентов (в т.ч. через формы Сервиса), где это требуется. Согласие Клиента — отдельный документ, не часть настоящей Оферты.",
          `7.6. Подробности: Политика конфиденциальности (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.privacy}).`,
        ),
      },
      {
        heading: "8. Интеллектуальная собственность и контент Заказчика",
        paragraphs: p(
          "8.1. Исключительные права на Сервис, дизайн, базы (кроме данных Заказчика), товарные знаки Бай.Спорт принадлежат Исполнителю или правообладателям.",
          "8.2. Данные и материалы, загруженные Заказчиком / пользователями клуба, остаются под контролем Заказчика. Заказчик гарантирует наличие прав на их использование.",
          "8.3. Заказчик не вправе копировать, декомпилировать Сервис, предоставлять доступ третьим лицам вне тарифа, использовать Сервис для рассылки спама или вредоносного ПО.",
        ),
      },
      {
        heading: "9. Доступность Сервиса и техработы",
        paragraphs: p(
          "9.1. Исполнитель стремится обеспечивать работоспособность Сервиса круглосуточно, но не гарантирует доступность 100% времени.",
          "9.2. Допускаются плановые и внеплановые техработы, обновления и устранение инцидентов. О существенных плановых работах Исполнитель по возможности уведомляет заранее.",
          "9.3. Исполнитель не гарантирует коммерческий результат деятельности клуба (число клиентов, выручку и т.п.).",
        ),
      },
      {
        heading: "10. Конфиденциальность",
        paragraphs: p(
          "10.1. Стороны обязуются не раскрывать конфиденциальную информацию другой стороны, полученную в связи с Договором, кроме случаев, необходимых для исполнения Договора, требований закона или согласия стороны.",
          "10.2. Факт использования Сервиса клубом и обезличенная статистика не считаются нарушением конфиденциальности.",
        ),
      },
      {
        heading: "11. Ответственность",
        paragraphs: p(
          "11.1. Сервис предоставляется «как есть». В максимальной степени, допускаемой законом, Исполнитель не отвечает за косвенные убытки, упущенную выгоду и потери из‑за решений Заказчика на основе данных в Сервисе.",
          "11.2. Совокупная ответственность Исполнителя по требованиям, связанным с Офертой, ограничивается суммой, фактически уплаченной Заказчиком Исполнителю за Сервис за последний 1 (один) месяц до события, если иное не предусмотрено императивными нормами. Ограничение не применяется к умыслу Исполнителя.",
          "11.3. Исполнитель не отвечает за сбои сетей связи, действия платёжных систем и хостинг-провайдеров вне разумного контроля, действия пользователей клуба и споры клуба с Клиентами.",
        ),
      },
      {
        heading: "12. Срок, изменение, расторжение и данные",
        paragraphs: p(
          "12.1. Договор действует с акцепта до прекращения использования Сервиса / удаления аккаунта или расторжения по Оферте.",
          "12.2. Исполнитель может изменять Оферту, публикуя новую редакцию с указанием даты. Продолжение использования после вступления изменений в силу означает согласие с ними, если иное не требуется законом. Существенные изменения по возможности доводятся через интерфейс.",
          "12.3. Заказчик может прекратить использование в любое время. Исполнитель может приостановить или прекратить доступ при нарушении Оферты или неоплате.",
          "12.4. По запросу Заказчика в разумный срок после прекращения Договора Исполнитель содействует выгрузке доступных данных клуба средствами Сервиса (если функция предусмотрена) либо в согласованном формате; далее данные удаляются или обезличиваются, если иное не требуется законом.",
        ),
      },
      {
        heading: "13. Форс-мажор",
        paragraphs: p(
          "13.1. Стороны освобождаются от ответственности за неисполнение, вызванное обстоятельствами непреодолимой силы (стихийные бедствия, войны, акты органов власти, массовые сбои сетей и инфраструктуры), при условии уведомления другой стороны в разумный срок.",
        ),
      },
      {
        heading: "14. Претензии и споры",
        paragraphs: p(
          `14.1. До суда сторона направляет письменную претензию (в т.ч. на ${LEGAL_OPERATOR.supportEmail}). Срок ответа — 10 (десять) рабочих дней с получения, если иной срок не установлен законом.`,
          "14.2. Применяется право Российской Федерации. Споры рассматриваются в суде по месту нахождения Исполнителя, если иное не установлено законом о защите прав потребителей (когда применимо к Заказчику-потребителю).",
        ),
      },
      {
        heading: "15. Заключительные положения",
        paragraphs: p(
          "15.1. Недействительность отдельного положения не влечёт недействительности остальных.",
          "15.2. Бездействие Исполнителя при нарушении не означает отказа от прав.",
          `15.3. По вопросам Оферты: ${LEGAL_OPERATOR.supportEmail}.`,
        ),
      },
    ],
  },

  privacy: {
    id: "privacy",
    path: LEGAL_PATHS.privacy,
    title: "Политика конфиденциальности",
    description:
      "Политика обработки персональных данных в сервисе Бай.Спорт (152-ФЗ).",
    updatedAt: updated,
    version: LEGAL_DOCS_VERSION,
    sections: [
      {
        heading: "1. Общие сведения",
        paragraphs: p(
          `1.1. Политика описывает обработку персональных данных (ПДн) в сервисе «${LEGAL_OPERATOR.brandName}» (${LEGAL_OPERATOR.siteUrl}), редакция ${LEGAL_DOCS_VERSION} от ${updated}.`,
          `1.2. Оператор в отношении данных владельцев/сотрудников платформы, обращений в поддержку и биллинга подписки: ${LEGAL_OPERATOR.entityName} (ИНН ${LEGAL_OPERATOR.inn}, ${LEGAL_OPERATOR.ogrnOrOgrnip}, адрес: ${LEGAL_OPERATOR.legalAddress}). Контакт по ПДн: ${LEGAL_OPERATOR.privacyEmail}.`,
          "1.3. В отношении ПДн Клиентов клуба оператором является соответствующий клуб. Бай.Спорт — обработчик по поручению клуба (см. Оферту).",
          "1.4. Политика не заменяет отдельное согласие субъекта. Согласие оформляется отдельным документом и отдельной отметкой в формах.",
          `1.5. Связанные документы: Оферта; cookies (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.cookies}); платежи (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.payments}); согласие владельца (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.ownerConsent}); согласие клиента (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.clientConsent}).`,
        ),
      },
      {
        heading: "2. Категории субъектов",
        paragraphs: p(
          "2.1. Владельцы клубов и их уполномоченные лица.",
          "2.2. Сотрудники клуба (администраторы, тренеры), которым открыт доступ.",
          "2.3. Клиенты клубов и законные представители — по поручению клуба.",
          "2.4. Посетители публичных страниц сайта (технические данные, cookies).",
        ),
      },
      {
        heading: "3. Какие данные обрабатываются",
        paragraphs: p(
          "3.1. Владелец и сотрудники: ФИО, email, телефон, данные входа, сведения о клубе, биллинг подписки (статус, идентификаторы у провайдера — без полного номера карты), логи доступа.",
          "3.2. Клиенты клуба (по поручению): ФИО, контакты, дата рождения, абонементы, посещения, платежи в клубе, сообщения в чатах, факты согласий, иные данные из форм.",
          "3.3. При онлайн-оплате: сумма, назначение, статус, идентификаторы у провайдера; реквизиты карты обрабатывает провайдер.",
          "3.4. Технические: IP, cookies и аналоги, user-agent, данные устройства, метрики (при подключении аналитики).",
        ),
      },
      {
        heading: "4. Цели и правовые основания",
        paragraphs: p(
          "4.1. Исполнение договора (Оферты): регистрация, доступ к Сервису, поддержка, биллинг.",
          "4.2. Соблюдение закона: учёт, налоги, ответы на законные запросы.",
          "4.3. Согласие — когда запрошено отдельно в интерфейсе.",
          "4.4. Законный интерес — безопасность, предотвращение злоупотреблений, улучшение продукта в обезличенном виде, где применимо.",
          "4.5. Поручение клуба — обработка ПДн Клиентов для CRM и платежей клуба.",
        ),
      },
      {
        heading: "5. Локализация и трансграничная передача",
        paragraphs: p(
          "5.1. Обработка и хранение ПДн осуществляются с использованием инфраструктуры на территории Российской Федерации.",
          "5.2. Трансграничная передача ПДн Исполнителем не осуществляется, за исключением случаев, когда это неизбежно по выбору Заказчика (например, иностранный сервис, подключённый самим клубом) — тогда ответственность за основание передачи несёт Заказчик.",
        ),
      },
      {
        heading: "6. Передача третьим лицам",
        paragraphs: p(
          "6.1. Подрядчики: хостинг и хранение, email-рассылка, платёжные сервисы, аналитика сайта — в необходимом объёме и при обязательствах о конфиденциальности.",
          "6.2. Раскрытие по требованию закона, суда или уполномоченного органа.",
          "6.3. Бай.Спорт не продаёт персональные данные.",
        ),
      },
      {
        heading: "7. Сроки хранения",
        paragraphs: p(
          "7.1. Данные аккаунта — на срок договора и далее в сроки, необходимые для защиты прав и исполнения закона (в т.ч. бухгалтерия — как правило не менее сроков, установленных налоговым законодательством).",
          "7.2. Данные Клиентов клуба — пока клуб использует Сервис и/или пока клуб не удалит их; после прекращения договора — удаление или обезличивание в разумный срок (ориентир — до 60 дней), если иное не требуется законом или поручением клуба.",
          "7.3. Логи безопасности — ограниченный срок, необходимый для расследования инцидентов.",
        ),
      },
      {
        heading: "8. Права субъектов и порядок обращений",
        paragraphs: p(
          "8.1. Субъект вправе запросить доступ, уточнение, блокирование или удаление, отозвать согласие (если обработка на согласии), ограничить обработку в случаях, предусмотренных 152‑ФЗ, обратиться в Роскомнадзор.",
          `8.2. Запросы владельцев/сотрудников платформы: ${LEGAL_OPERATOR.privacyEmail}. В запросе укажите ФИО, контакт и суть требования. Срок ответа — до 10 рабочих дней (если иной срок не установлен законом), с возможностью продления в сложных случаях с уведомлением.`,
          "8.3. Клиентам клуба по данным в CRM — обращение в клуб (оператор). Бай.Спорт содействует клубу в рамках поручения.",
        ),
      },
      {
        heading: "9. Автоматизированные решения",
        paragraphs: p(
          "9.1. Исполнитель не принимает решений, порождающих юридические последствия для субъекта, исключительно на основе автоматизированной обработки ПДн без участия человека, за исключением технических антифрод-проверок доступа.",
        ),
      },
      {
        heading: "10. Cookies",
        paragraphs: p(
          `10.1. Подробности — Политика cookies (${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.cookies}). Уведомление о cookies показывается в интерфейсе; после «Принять» могут подключаться аналитические cookies.`,
        ),
      },
      {
        heading: "11. Защита и инциденты",
        paragraphs: p(
          "11.1. Меры: разграничение доступа, HTTPS, резервное копирование, учёт действий в разумном объёме, организационные процедуры.",
          "11.2. При утечке ПДн Исполнитель действует в порядке, предусмотренном 152‑ФЗ (уведомление уполномоченного органа и субъектов — когда это требуется), и информирует Заказчика в части ПДн Клуба.",
        ),
      },
      {
        heading: "12. Изменения Политики",
        paragraphs: p(
          "12.1. Актуальная редакция публикуется на этой странице с датой и версией. Существенные изменения могут доводиться через интерфейс Сервиса.",
        ),
      },
    ],
  },

  cookies: {
    id: "cookies",
    path: LEGAL_PATHS.cookies,
    title: "Политика использования cookies",
    description:
      "Cookie и аналогичные технологии на сайте и в сервисе Бай.Спорт.",
    updatedAt: updated,
    version: LEGAL_DOCS_VERSION,
    sections: [
      {
        heading: "1. Что такое cookies",
        paragraphs: p(
          "1.1. Cookies — данные, сохраняемые браузером. Аналоги: local storage, session storage, пиксели аналитики.",
          `1.2. Политика относится к «${LEGAL_OPERATOR.brandName}» (${LEGAL_OPERATOR.siteUrl}), страницам входа и кабинетам. Редакция ${LEGAL_DOCS_VERSION}.`,
        ),
      },
      {
        heading: "2. Категории",
        paragraphs: p(
          "2.1. Строго необходимые — сессия, авторизация, безопасность, CSRF, выбор клуба/портала, работа форм. Правовое основание — исполнение договора / обеспечение работы Сервиса. Без них кабинет может не работать.",
          "2.2. Функциональные — удобство интерфейса (закрытие подсказок, локальные настройки).",
          "2.3. Аналитические — статистика посещений и ошибок (например, Яндекс.Метрика). Могут обрабатываться как ПДн в связке с техническими идентификаторами. Подключаются после нажатия «Принять» в cookie-баннере.",
          "2.4. Маркетинговые — по умолчанию не используются. Если появятся на лендинге, потребуется отдельное согласие.",
        ),
      },
      {
        heading: "3. Срок хранения",
        paragraphs: p(
          "3.1. Session — до закрытия браузера.",
          "3.2. Persistent — от нескольких дней до срока технологии (часто до 1–2 лет для аналитики) либо до очистки вами данных сайта.",
          "3.3. Факт принятия в cookie-баннере сохраняется локально в браузере (localStorage), чтобы не показывать плашку повторно.",
        ),
      },
      {
        heading: "4. Управление",
        paragraphs: p(
          "4.1. Браузер: ограничение или удаление cookies. Блокировка необходимых cookies может сделать вход и оплату невозможными.",
          `4.2. Сбросить принятое уведомление о cookies можно очисткой данных сайта в браузере (баннер появится снова) или обращением на ${LEGAL_OPERATOR.privacyEmail}.`,
        ),
      },
      {
        heading: "5. Третьи стороны",
        paragraphs: p(
          "5.1. Платёжные виджеты могут ставить cookies на доменах провайдера — по их правилам.",
          "5.2. Провайдер аналитики (при подключении) обрабатывает данные по своей политике; Исполнитель указывает факт использования в настройках/этой Политике.",
          `5.3. ПДн в целом: ${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.privacy}. Контакт: ${LEGAL_OPERATOR.privacyEmail}.`,
        ),
      },
    ],
  },

  payments: {
    id: "payments",
    path: LEGAL_PATHS.payments,
    title: "Условия платежей",
    description:
      "Подписка на Бай.Спорт и онлайн-оплаты клиентов клуба (эквайринг).",
    updatedAt: updated,
    version: LEGAL_DOCS_VERSION,
    sections: [
      {
        heading: "1. Два контура платежей",
        paragraphs: p(
          `1.1. Подписка SaaS — плата Заказчика Исполнителю за доступ к «${LEGAL_OPERATOR.brandName}».`,
          "1.2. Оплата услуг клуба Клиентом — абонементы, разовые занятия, задолженности. Получатель — клуб через свой эквайринг. Исполнитель не продаёт занятия и не удерживает эти суммы как свою выручку.",
          `1.3. Редакция: ${LEGAL_DOCS_VERSION} от ${updated}. Валюта расчётов в интерфейсе — российский рубль (₽), если не указано иное.`,
        ),
      },
      {
        heading: "2. Оплата подписки на Бай.Спорт",
        paragraphs: p(
          `2.1. Получатель: ${LEGAL_OPERATOR.entityName}, ИНН ${LEGAL_OPERATOR.inn}.`,
          "2.2. Способ: карта или иной метод в кабинете владельца через платёжного провайдера.",
          "2.3. До оплаты отображаются сумма, период и состав тарифа. Нажимая оплату, Заказчик подтверждает заказ услуги доступа на указанных условиях.",
          "2.4. Момент оплаты — успешное подтверждение провайдера. Доступ активируется/продлевается согласно тарифу.",
          "2.5. Неуспешная оплата / истечение карты — доступ может быть ограничен до успешного списания.",
          "2.6. Чек / документ об оплате подписки — в порядке 54‑ФЗ и настроек Исполнителя/провайдера (если применимо). Копия может направляться на email Заказчика.",
          `2.7. Вопросы: ${LEGAL_OPERATOR.supportEmail}.`,
        ),
      },
      {
        heading: "3. Автопродление и смена тарифа",
        paragraphs: p(
          "3.1. Если в интерфейсе включено автопродление, подписка продлевается на следующий период с повторным списанием, пока не отключено Заказчиком или не исчерпан способ оплаты.",
          "3.2. Смена тарифа (апгрейд/даунгрейд) — по правилам, показанным в кабинете (в т.ч. перерасчёт или с даты следующего периода).",
        ),
      },
      {
        heading: "4. Возвраты по подписке SaaS",
        paragraphs: p(
          "4.1. Заявление о возврате — на email поддержки с указанием клуба, даты платежа и причины.",
          "4.2. Рассмотрение — в разумный срок (ориентир до 10 рабочих дней) с учётом фактически предоставленного доступа, правил тарифа и законодательства РФ.",
          "4.3. При полном возврате за неиспользованный период доступ за соответствующий период может быть прекращён.",
          "4.4. Chargeback банка может повлечь приостановку доступа до выяснения.",
        ),
      },
      {
        heading: "5. Онлайн-оплата Клиентами клуба",
        paragraphs: p(
          "5.1. Клуб подключает ЮKassa, Т‑Банк или иной эквайринг своим договором. Комиссии и вывод средств — по договору клуба с провайдером.",
          "5.2. Клиент оплачивает клубу. Деньги поступают клубу (или на счёт по договору клуба с эквайером).",
          "5.3. Бай.Спорт передаёт провайдеру сумму, назначение и идентификаторы заказа CRM для завершения оплаты и смены статуса в Сервисе.",
          "5.4. Возвраты Клиенту, претензии по занятиям — зона ответственности клуба. Клиент обращается в клуб.",
          "5.5. Чеки Клиенту (54‑ФЗ) обеспечивает клуб / эквайер по схеме клуба. Платформа может передавать данные для фискализации, если интеграция включена.",
        ),
      },
      {
        heading: "6. Безопасность",
        paragraphs: p(
          "6.1. Ввод карты — на стороне провайдера (PCI DSS). Бай.Спорт не хранит полный номер карты, CVV, срок действия.",
          "6.2. Статусы обновляются по webhook / API провайдера.",
        ),
      },
      {
        heading: "7. Изменения",
        paragraphs: p(
          "7.1. Новая редакция публикуется на этой странице. Продолжение оплат после публикации означает принятие обновлений в части, не противоречащей императивным нормам.",
        ),
      },
    ],
  },

  clientConsent: {
    id: "clientConsent",
    path: LEGAL_PATHS.clientConsent,
    title: "Согласие на обработку персональных данных (клиенты клуба)",
    description:
      "Отдельное согласие по ст. 9 152-ФЗ для клиента / законного представителя.",
    updatedAt: updated,
    version: LEGAL_DOCS_VERSION,
    sections: [
      {
        heading: "1. Субъект и оператор",
        paragraphs: p(
          "1.1. Субъект — клиент клуба либо родитель / законный представитель несовершеннолетнего (свои данные и данные ребёнка).",
          "1.2. Оператор — спортивный клуб, на сайте / по ссылке которого идёт регистрация (далее — «Клуб»). Реквизиты Клуба — в интерфейсе регистрации / на сайте Клуба.",
          `1.3. Обработчик по поручению Клуба: ${LEGAL_OPERATOR.entityName} («${LEGAL_OPERATOR.brandName}», ${LEGAL_OPERATOR.siteUrl}), ИНН ${LEGAL_OPERATOR.inn}, адрес: ${LEGAL_OPERATOR.legalAddress}.`,
        ),
      },
      {
        heading: "2. Цель обработки",
        paragraphs: p(
          "2.1. Регистрация и учёт в Клубе; организация занятий; учёт посещаемости и оплат услуг Клуба; связь по занятиям; личный кабинет; онлайн-оплата услуг Клуба (если подключена).",
        ),
      },
      {
        heading: "3. Перечень персональных данных",
        paragraphs: p(
          "3.1. ФИО; дата рождения; телефон; email; сведения о группах, посещениях, абонементах и платежах; иные данные, добровольно указанные в формах.",
        ),
      },
      {
        heading: "4. Действия и способы",
        paragraphs: p(
          "4.1. Сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, передача (доступ обработчику — платформе и платёжному провайдеру при оплате), блокирование, удаление, уничтожение.",
          "4.2. С использованием средств автоматизации (ИС Клуба на Бай.Спорт) и без таковых — по усмотрению Клуба.",
        ),
      },
      {
        heading: "5. Срок и отзыв",
        paragraphs: p(
          "5.1. С момента отметки в форме на период обслуживания в Клубе и сроки, установленные законом.",
          "5.2. Отзыв — обращением в Клуб. После отзыва обработка на основании согласия прекращается, кроме случаев иных оснований по 152‑ФЗ.",
        ),
      },
      {
        heading: "6. Несовершеннолетние",
        paragraphs: p(
          "6.1. При регистрации ребёнка согласие даёт законный представитель в отношении данных ребёнка и своих контактов.",
        ),
      },
      {
        heading: "7. Дополнительно",
        paragraphs: p(
          `7.1. Политика платформы: ${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.privacy}. Платежи: ${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.payments}.`,
          "7.2. Рассылки, фото, медицина — отдельные согласия Клуба, если запрашиваются.",
          `7.3. Версия документа: ${LEGAL_DOCS_VERSION}.`,
        ),
      },
    ],
  },

  ownerConsent: {
    id: "ownerConsent",
    path: LEGAL_PATHS.ownerConsent,
    title: "Согласие на обработку персональных данных (владелец клуба)",
    description:
      "Отдельное согласие по ст. 9 152-ФЗ при регистрации владельца / создании клуба.",
    updatedAt: updated,
    version: LEGAL_DOCS_VERSION,
    sections: [
      {
        heading: "1. Субъект и оператор",
        paragraphs: p(
          "1.1. Субъект — физическое лицо, создающее аккаунт владельца клуба в Бай.Спорт.",
          `1.2. Оператор: ${LEGAL_OPERATOR.entityName}, ИНН ${LEGAL_OPERATOR.inn}, ${LEGAL_OPERATOR.ogrnOrOgrnip}, адрес: ${LEGAL_OPERATOR.legalAddress}. Контакт: ${LEGAL_OPERATOR.privacyEmail}.`,
        ),
      },
      {
        heading: "2. Цель обработки",
        paragraphs: p(
          "2.1. Регистрация и идентификация аккаунта; заключение и исполнение договора на использование Сервиса (Оферта); поддержка; биллинг подписки; безопасность аккаунта.",
        ),
      },
      {
        heading: "3. Перечень персональных данных",
        paragraphs: p(
          "3.1. ФИО; email; телефон (если указан); данные для входа; сведения о клубе, нужные для услуги; технические данные (IP, журналы) для безопасности и исполнения договора.",
        ),
      },
      {
        heading: "4. Действия и способы",
        paragraphs: p(
          "4.1. Сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, передача подрядчикам в пределах услуги (хостинг, почта, платёжный провайдер подписки), блокирование, удаление, уничтожение.",
          "4.2. Автоматизированная обработка на территории РФ.",
        ),
      },
      {
        heading: "5. Срок и отзыв",
        paragraphs: p(
          "5.1. С отметки при регистрации на срок пользования Сервисом и сроки по закону.",
          `5.2. Отзыв: ${LEGAL_OPERATOR.privacyEmail}. Отзыв не затрагивает законность обработки до отзыва и обработку, необходимую для договора / закона без согласия.`,
        ),
      },
      {
        heading: "6. Отдельность согласия",
        paragraphs: p(
          "6.1. Настоящее согласие оформляется отдельно от акцепта Оферты (отдельная галочка).",
          "6.2. Обработка ПДн Клиентов клуба — по поручению клуба в Оферте и не заменяется этим согласием.",
          `6.3. Оферта: ${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.offer}. Политика: ${LEGAL_OPERATOR.siteUrl}${LEGAL_PATHS.privacy}. Версия: ${LEGAL_DOCS_VERSION}.`,
        ),
      },
    ],
  },
};

export function getLegalDocument(id) {
  return LEGAL_DOCUMENTS[id] || null;
}
